import { DetailedPageWrapper } from 'district-ui-client/components/reporting/detailed-page-wrapper'
import { or } from 'ember-truth-helpers'
import { not } from 'ember-truth-helpers'
import { TimeOnTaskUsageChart } from 'district-ui-client/components/charts/time-on-task/usage/component'
import { TimeOnTaskTable } from 'district-ui-client/components/reporting/time-on-task/table'
import Component from '@glimmer/component'
import type RexTimeOnTaskRoute from 'district-ui-client/reporting/ui-scope/rex/time-on-task/route'
import RouteTemplate from 'ember-route-template'
import { SubscriptionType } from 'district-ui-client/domain/subscription-type'
import themeKey from 'district-ui-client/helpers/theme-key'

interface Signature {
  Args: {
    model: ModelFor<RexTimeOnTaskRoute>
  }
}

export class ReportingRexTimeOnTaskRouteTemplate extends Component<Signature> {
  get isDistrictScope() {
    return this.args.model.uiScope.scope === 'district'
  }

  get timeOnTaskHistoryDistrict() {
    const { timeOnTaskHistory } = this.args.model
    if (timeOnTaskHistory && 'district' in timeOnTaskHistory) {
      return timeOnTaskHistory
    }
    return null
  }

  <template>
    <DetailedPageWrapper
      @empty={{or (not @model.timeOnTaskUsage) (not @model.timeOnTaskHistory)}}
      @viewMode={{if this.isDistrictScope "table" "chart"}}
    >
      {{#if @model.timeOnTaskUsage}}
        <div class="mb-5 rounded-md bg-white p-2 print:rounded-none print:border print:border-dusty-black-50">
          <TimeOnTaskUsageChart
            data-test-time-on-task-usage-chart
            @data={{@model.timeOnTaskUsage}}
            @uiScope={{@model.uiScope}}
            @mainTheme={{themeKey SubscriptionType.Reading}}
          />
        </div>
      {{/if}}

      {{#if this.timeOnTaskHistoryDistrict}}
        <TimeOnTaskTable @schools={{@model.scopedData.schools}} @data={{this.timeOnTaskHistoryDistrict}} />
      {{/if}}
    </DetailedPageWrapper>
  </template>
}

export default RouteTemplate(ReportingRexTimeOnTaskRouteTemplate)
